import classNames from 'classnames';
import React from 'react';
import NewReorderableList from './NewReorderableList';
import * as styles from './SectionList.module.scss';
import SidebarSectionIcon from './SidebarSectionIcon';
import { getSidebarSectionNameWithFallback } from './SidebarSectionsProvider';
import Badge from '../components/Badge';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';
import hideIcon from '../icons/non-prefilled/16x16/hide.svg';
import readIcon from '../icons/non-prefilled/16x16/read.svg';

const SectionList = ({
  children,
  ...props
}: Omit<React.ComponentProps<typeof NewReorderableList>, 'name'>) => {
  return (
    <NewReorderableList {...props} name="sections">
      <div className={styles.container}>{children}</div>
    </NewReorderableList>
  );
};

const SECTION_FRAGMENT = gql(`
  fragment SectionListRow_Section on Section {
    id
    name
    ...SidebarSectionIcon_section
  }
`);

interface SectionListRowProps {
  section: DocumentType<typeof SECTION_FRAGMENT>;
  visible: boolean;
  teamSection: boolean;
  selected?: boolean;
  onClick?: () => void;
  onVisibilityButtonClick?: () => void;
  index: number;
}

const SectionListRow = ({
  section,
  selected,
  visible,
  teamSection,
  onClick,
  onVisibilityButtonClick,
  index,
}: SectionListRowProps) => {
  return (
    <NewReorderableList.Row
      id={section.id}
      index={index}
      className={styles.rowContainer}
    >
      {() => (
        <div
          className={classNames(styles.content, {
            [styles.isSelected]: selected,
            [styles.isVisible]: visible,
          })}
        >
          <Button className={styles.contentButton} onClick={onClick}>
            <NewReorderableList.DragIndicator
              className={styles.contentButtonContent}
              index={index}
            >
              <span aria-hidden className={styles.icon}>
                <SidebarSectionIcon section={section} />
              </span>
              <span className={styles.name}>
                {getSidebarSectionNameWithFallback(section.name)}
              </span>
              <span className={styles.nameBadgeContainer}>
                {teamSection && <Badge color="green">Team</Badge>}
              </span>
            </NewReorderableList.DragIndicator>
          </Button>
          <Button
            className={styles.visibilityIconButton}
            onClick={onVisibilityButtonClick}
          >
            <SVGIcon className={styles.visibilityIcon}>
              {visible ? readIcon : hideIcon}
            </SVGIcon>
          </Button>
        </div>
      )}
    </NewReorderableList.Row>
  );
};

SectionList.Row = SectionListRow;

export default SectionList;
